import {useEffect} from 'react';

import {CIQUAL_DB_KEY, CiqualDatabase} from '@shared/models';

import {createDataStore} from '@shared_web/lib/data_store';
import {notifyError} from '@shared_web/lib/notification';

import {apiCall} from '@website_frontend/lib/api';

const nutriDbStore = createDataStore<CiqualDatabase>(undefined, {persist: {key: CIQUAL_DB_KEY}});
export function useNutriDb(): CiqualDatabase | undefined {
  const currentNutriDb = nutriDbStore.useData();
  useEffect(() => {
    // Trigger a fetch if the DB is not initialized
    if (currentNutriDb === undefined) {
      fetchNutriDb();
    }
  }, [currentNutriDb]);
  return currentNutriDb;
}

let isLoadingNutriDb = false;
function fetchNutriDb(): void {
  if (isLoadingNutriDb) {
    return;
  }
  isLoadingNutriDb = true;
  apiCall('POST /get-db-url', {version: CIQUAL_DB_KEY})
    .then(({url}) => {
      isLoadingNutriDb = false;
      fetch(url)
        .then(res => res.json())
        .then(db => nutriDbStore.setData(db))
        .catch(notifyError);
    })
    .catch(err => {
      isLoadingNutriDb = false;
      notifyError(err);
    });
}
